/**
 * FwmPhotoCard — the single card language: photograph on top, text below,
 * same shadow and lift on hover, whether it holds an event, a campaign, a
 * church or a book. Records with no uploaded artwork fall back to FWM's own
 * photography rather than an empty grey box.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FWM_CARD_ART, resolveImage } from './imagery';

export const FwmPhotoCard = ({
  image, index = 0, overline, title, blurb, meta, cta, to, onClick,
  badge, testId, children, delay = 0,
}) => {
  const navigate = useNavigate();
  const art = resolveImage(image) || FWM_CARD_ART[index % FWM_CARD_ART.length];
  const go = () => (onClick ? onClick() : to && navigate(to));
  return (
    <article className="fwm-photo-card fwm-rise" data-testid={testId}
             style={{ animationDelay: `${delay}ms` }}>
      <button type="button" onClick={go} className="fwm-photo-card-hit">
        <span className="fwm-photo-card-media">
          <img src={art} alt={typeof title === 'string' ? title : ''} loading="lazy" />
          {overline && <span className="fwm-photo-card-overline">{overline}</span>}
          {badge && <span className="fwm-photo-card-badge">{badge}</span>}
        </span>
        <span className="fwm-photo-card-body">
          <span className="fwm-photo-card-title">{title}</span>
          {blurb && <span className="fwm-photo-card-blurb">{blurb}</span>}
          {meta && <span className="fwm-photo-card-meta">{meta}</span>}
          {children}
          {cta && (
            <span className="fwm-photo-card-cta">
              {cta} <ArrowRight className="h-3.5 w-3.5" />
            </span>
          )}
        </span>
      </button>
    </article>
  );
};

export default FwmPhotoCard;
